module.exports = __webpack_public_path__ + "static/media/03.c8ef67c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/03.jpg
// module id = 372
// module chunks = 0